import React from 'react'

const Jeans = () => {
  return (
    <div>Jeans</div>
  )
}

export default Jeans